import { programInfo } from '@/mocks/programData';

export default function Contact() {
  return (
    <section id="contacto" className="py-20 md:py-28 bg-white">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-14">
            <span className="text-accent text-sm font-semibold uppercase tracking-wider">Contacto</span>
            <h2 className="font-display text-3xl md:text-4xl font-bold text-primary mt-3">
              Entre em Contacto
            </h2>
            <p className="text-gray-600 mt-4 max-w-xl mx-auto">
              Para mais informações ou esclarecimentos sobre o Mestrado em Educação Médica.
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            <div className="bg-warm-50 rounded-2xl p-6">
              <div className="w-12 h-12 rounded-xl bg-primary/10 flex items-center justify-center mb-4">
                <i className="ri-mail-line text-primary text-xl" />
              </div>
              <h3 className="font-bold text-primary mb-2">E-mail</h3>
              <p className="text-gray-600 text-sm">{programInfo.contactEmail}</p>
              <p className="text-gray-500 text-xs mt-1">Secretaria do Mestrado</p>
            </div>

            <div className="bg-warm-50 rounded-2xl p-6">
              <div className="w-12 h-12 rounded-xl bg-primary/10 flex items-center justify-center mb-4">
                <i className="ri-phone-line text-primary text-xl" />
              </div>
              <h3 className="font-bold text-primary mb-2">Telefone</h3>
              <p className="text-gray-600 text-sm">{programInfo.contactPhone}</p>
              <p className="text-gray-500 text-xs mt-1">Horário de expediente</p>
            </div>

            <div className="bg-warm-50 rounded-2xl p-6">
              <div className="w-12 h-12 rounded-xl bg-primary/10 flex items-center justify-center mb-4">
                <i className="ri-map-pin-line text-primary text-xl" />
              </div>
              <h3 className="font-bold text-primary mb-2">Localização</h3>
              <p className="text-gray-600 text-sm">Faculdade de Medicina</p>
              <p className="text-gray-500 text-xs mt-1">Universidade Agostinho Neto, Luanda</p>
            </div>
          </div>

          <div className="mt-10 grid md:grid-cols-2 gap-6">
            <div className="bg-primary rounded-2xl p-8 text-white">
              <h3 className="text-lg font-bold mb-4 flex items-center gap-2">
                <i className="ri-user-star-line text-accent" />
                Coordenação
              </h3>
              <div className="space-y-3 text-sm">
                <div className="flex items-start gap-3">
                  <i className="ri-user-line text-accent mt-0.5" />
                  <div>
                    <p className="font-semibold">{programInfo.coordinator}</p>
                    <p className="text-white/60">Coordenador do Mestrado</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <i className="ri-user-line text-accent mt-0.5" />
                  <div>
                    <p className="font-semibold">{programInfo.viceCoordinator}</p>
                    <p className="text-white/60">Coordenador Adjunto</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <i className="ri-user-line text-accent mt-0.5" />
                  <div>
                    <p className="font-semibold">{programInfo.secretary}</p>
                    <p className="text-white/60">Secretaria Pedagógica</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-warm-50 rounded-2xl p-8 border border-gray-100">
              <h3 className="text-lg font-bold text-primary mb-4 flex items-center gap-2">
                <i className="ri-links-line text-accent" />
                Links Úteis
              </h3>
              <div className="space-y-3">
                <a
                  href="https://www.cedumed.ao/medumed/regulamento.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-3 p-3 bg-white rounded-xl hover:shadow-sm transition-shadow"
                >
                  <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center">
                    <i className="ri-file-pdf-line text-primary" />
                  </div>
                  <div className="flex-1">
                    <p className="font-semibold text-primary text-sm">Regulamento do Mestrado</p>
                    <p className="text-gray-500 text-xs">Documento oficial PDF</p>
                  </div>
                  <i className="ri-external-link-line text-gray-400" />
                </a>
                <a
                  href="mailto:medumed@cedumed.ao"
                  className="flex items-center gap-3 p-3 bg-white rounded-xl hover:shadow-sm transition-shadow"
                >
                  <div className="w-10 h-10 rounded-lg bg-accent/10 flex items-center justify-center">
                    <i className="ri-mail-send-line text-accent" />
                  </div>
                  <div className="flex-1">
                    <p className="font-semibold text-primary text-sm">Solicitar Informações</p>
                    <p className="text-gray-500 text-xs">Enviar e-mail para secretaria</p>
                  </div>
                  <i className="ri-arrow-right-line text-gray-400" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}